import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import * as classnames from 'classnames';
import { RemoveIcon } from 'elc-icons';
import { ContentSpacing, breakpoint } from 'elc-base-theme';
import { translate, ITranslationsCollection } from 'elc-service';
import { transparentButton } from '../../theme/default-theme';

const CloseSearchIconWrapper = styled.button`
    top: ${ContentSpacing.space16};
    right: ${ContentSpacing.space16};
    z-index: 1;
    position: relative;
    float: right;
    text-align: center;
    ${transparentButton}
    ${breakpoint('desktop')`
        top: ${ContentSpacing.space24};
        right: ${ContentSpacing.space24};
        [dir='rtl'] & {
            float: left;
            left: ${ContentSpacing.space16};
            right: auto;
        }
    `};
`;

export interface IOverlayIconProps {
    toggleSearchOverlay(): void;
    translations?: ITranslationsCollection;
}

const searchIconCloseWrapperClassnames = classnames(
    'elc-search-close-icon-wrapper',
    'js-search-close-icon-wrapper'
);

const searchIconCloseClassnames = classnames('elc-search-close-icon', 'js-search-close-icon');

@translate(['closeLabel', 'searchButtonLabel'])
@observer
export class SearchCloseActiveScreen extends React.Component<IOverlayIconProps> {
    public render() {
        const { toggleSearchOverlay } = this.props;
        const translations = this.props.translations as ITranslationsCollection;
        const { closeLabel, searchButtonLabel } = translations;

        return (
            <CloseSearchIconWrapper
                className={searchIconCloseWrapperClassnames}
                onClick={toggleSearchOverlay}
                aria-label={`${closeLabel} ${searchButtonLabel}`}
                data-test-id="SEA-Close"
                title={`${closeLabel} ${searchButtonLabel}`}
            >
                <RemoveIcon className={searchIconCloseClassnames} />
            </CloseSearchIconWrapper>
        );
    }
}
